import React from 'react';

function NotFound(){
    return(
        <>
        <h1>Oops ! Page Not Found. </h1>
        </>
    )
}
export default NotFound;